module.exports = "dist/fc78759e93a6cac50458610e3d9d63a0.woff";


//////////////////
// WEBPACK FOOTER
// ./~/materialize-css/fonts/roboto/Roboto-Medium.woff
// module id = 217
// module chunks = 0